import { render, staticRenderFns } from "./PasswortAendernModal.vue?vue&type=template&id=8758639e"
import script from "./PasswortAendernModal.vue?vue&type=script&lang=js"
export * from "./PasswortAendernModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports